<template>
  <div class="pricing-page">
    <!-- 产品特点介绍 -->
    <section class="features-section" data-aos="fade-up">
      <div class="container">
        <h1 class="section-title">多种合作方式供您选择</h1>
        <p class="section-subtitle">根据您的需求，为您提供最适合的解决方案</p>

        <!-- <el-row :gutter="30" class="features-list">
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            v-for="(feature, index) in features"
            :key="index"
            data-aos="fade-up"
            :data-aos-delay="100 * (index + 1)"
          >
            <div class="feature-card">
              <div class="feature-icon">
                <i :class="feature.icon" :style="{ color: primaryColor }"></i>
              </div>
              <h3>{{ feature.title }}</h3>
              <p>{{ feature.description }}</p>
            </div>
          </el-col>
        </el-row> -->

        <div class="carousel-container" data-aos="fade-up" data-aos-delay="200">
          <div class="carousel-track" ref="carouselTrack">
            <div
              v-for="(item, index) in solutions"
              :key="index"
              class="carousel-card"
              :data-aos="'flip-up'"
              :data-aos-delay="index * 100"
            >
              <div class="card-image">
                <img :src="item.imgPlaceholder" alt="" />
              </div>
              <div class="card-content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p>
                <!-- <el-button type="text" class="detail-link"
                  >查看详情 <i class="el-icon-arrow-right"></i
                ></el-button> -->
              </div>
            </div>
          </div>
          <button class="carousel-nav prev" @click="scrollCarousel(-1)">
            <i class="el-icon-arrow-left"></i>
          </button>
          <button class="carousel-nav next" @click="scrollCarousel(1)">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>

        <div class="cta-buttons" data-aos="fade-up" data-aos-delay="400">
          <!-- <el-button
            type="primary"
            round
            @click="handleFreeTrial"
            class="cta-button"
          >
            <i class="el-icon-view"></i> 免费体验
          </el-button> -->
          <el-button round @click="_goContact" class="cta-button">
            <i class="el-icon-chat-dot-round"></i> 咨询价格方案
          </el-button>
        </div>
      </div>
    </section>

    <!-- 常见价格问题 -->
    <section class="faq-section" data-aos="fade-up">
      <div class="container">
        <h2 class="section-title">常见价格问题</h2>

        <el-collapse v-model="activeFaq" accordion class="faq-accordion">
          <el-collapse-item
            v-for="(item, index) in faqs"
            :key="index"
            :name="index + 1"
          >
            <template slot="title">
              <div class="faq-title">
                <i
                  class="el-icon-question"
                  :style="{ color: primaryColor }"
                ></i>
                {{ item.question }}
              </div>
            </template>
            <div class="faq-content">{{ item.answer }}</div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </section>

    <!-- 咨询表单弹窗 -->
    <el-dialog
      title="咨询价格方案"
      :visible.sync="showContactDialog"
      width="600px"
    >
      <el-form :model="contactForm" label-width="100px">
        <el-form-item label="您的姓名">
          <el-input
            v-model="contactForm.name"
            placeholder="请输入您的姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input
            v-model="contactForm.contact"
            placeholder="请输入电话或邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input
            v-model="contactForm.company"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="需求描述">
          <el-input
            type="textarea"
            :rows="4"
            v-model="contactForm.requirements"
            placeholder="请简要描述您的业务需求和预算"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showContactDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitContactForm"
          >提交咨询</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      solutions: [
        {
          title: "省级代理商",
          description: `省级代理商享有全省独家代理权，可获得区域内所有市级代理商
的加盟费提成，以及平台交易手续费的一定比例分成。
公司为省级代理商提供全方位市场推广支持，包括品牌宣传、活
动策划、培训指导等，助力代理商快速拓展市场。`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/hz1.png",
        },
        {
          title: "市级代理商",
          description: `市级代理商负责本市及下辖县级区域的市场拓展，享有区域内独
家代理权，可获得县级代理商加盟费提成及平台交易手续费分成。
公司协助市级代理商建立销售团队，提供销售工具与技术支持，
定期组织培训与交流活动，提升代理商销售能力。`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/hz2.png",
        },
        {
          title: "区/县级平台代理商",
          description: `区、县级代理商专注于本地市场的开发与维护，可获得平台交易手续
费的较高比例分成，以及用户年费、手表销售等收益。
公司为区、县级代理商提供一对一业务指导，协助其与当地医疗机构、
养老机构建立合作关系，快速打开市场局面。`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/hz3.png",
        },
        {
          title: "平台伙伴",
          description: `加入善信医养‘平台伙伴计划’，整合本地优质医养资源，入驻善信医养APP，为长者提供便捷服务，并享受线上交易分成收益。`,
          imgPlaceholder:
            "https://upload.shanxinyy.com/homepage/%E5%88%86%E6%94%AF%E5%A4%A7%E5%B1%8F.jpg",
        },
        {
          title: "手表代理商",
          description: `手表代理商
区域保护——严格划分代理区域，避免恶性竞争；
利润保障——阶梯式销售返利，销量越高，返点越高；
营销支持——提供宣传物料、线上推广及地推活动扶持；
培训赋能——定期产品培训、销售技巧及售后服务指导；
数字化管理——配备智能后台系统，实时查看销售数据及客户反馈；
售后无忧——提供快速维修及退换货支持，降低代理商运营风险。`,
          imgPlaceholder: "https://upload.shanxinyy.com/homepage/znsb.jpg",
        },
      ],
      primaryColor: "#f97d01",
      features: [
        {
          icon: "el-icon-cpu",
          title: "高性能处理",
          description: "采用先进技术架构，确保系统稳定高效运行",
        },
        {
          icon: "el-icon-lock",
          title: "安全保障",
          description: "多重加密保护，确保您的数据安全无忧",
        },
        {
          icon: "el-icon-connection",
          title: "专利优势",
          description:
            "已获得两项国家发明专利,五项软件著作权,国家级科技型中小企业",
        },
        {
          icon: "el-icon-data-line",
          title: "智能分析",
          description: "内置AI分析工具，提供数据洞察支持",
        },
        {
          icon: "el-icon-headset",
          title: "专业支持",
          description: "7×24小时技术支持团队随时待命",
        },
        {
          icon: "el-icon-refresh",
          title: "灵活扩展",
          description: "按需扩展资源，随业务增长而增长",
        },
      ],
      faqs: [
        // {
        //   question: "是否有免费试用期？",
        //   answer:
        //     "我们提供14天的免费试用期，您可以在试用期内体验全部功能，无需提供任何付款信息。",
        // },
        {
          question: "价格是如何计算的？",
          answer:
            "我们的定价基于多种因素，包括用户数量、功能模块、存储需求等。我们会根据您的具体需求提供定制化的报价方案。",
        },
        {
          question: "支持哪些付款方式？",
          answer:
            "我们支持银行转账、支付宝、微信支付等多种付款方式，也接受企业年付方式并享有额外折扣。",
        },
        // {
        //   question: "如果超出资源限制会怎样？",
        //   answer:
        //     "我们会提前通知您资源使用情况，您可以选择升级套餐或按量付费，不会突然中断服务。",
        // },
        {
          question: "是否有隐藏费用？",
          answer:
            "我们承诺价格透明，所有费用都会在合同中明确列出，不会有任何隐藏费用或强制消费。",
        },
      ],
      activeFaq: "1",
      showContactDialog: false,
      contactForm: {
        name: "",
        contact: "",
        company: "",
        requirements: "",
      },
    };
  },
  mounted() {
    // 初始化AOS动画
    if (typeof AOS !== "undefined") {
      AOS.init({
        duration: 800,
        easing: "ease-in-out",
        once: true,
      });
    }
  },
  methods: {
    scrollCarousel(direction) {
      const track = this.$refs.carouselTrack;
      const cardWidth = track.querySelector(".carousel-card").offsetWidth + 30; // 包含margin
      track.scrollBy({ left: direction * cardWidth * 2, behavior: "smooth" });
    },
    handleFreeTrial() {
      this.$router.push("/free-trial");
      // 或者 window.location.href = '/free-trial';
    },
    handleContact() {
      this.showContactDialog = true;
    },
    submitContactForm() {
      // 这里添加表单提交逻辑
      this.$message.success("咨询已提交，我们的销售代表将在24小时内与您联系！");
      this.showContactDialog = false;
      this.contactForm = {
        name: "",
        contact: "",
        company: "",
        requirements: "",
      };
    },
  },
};
</script>

<style scoped>
.carousel-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;

  .carousel-track {
    display: flex;
    gap: 30px;
    padding: 20px 0;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .carousel-card {
    flex: 0 0 calc(33.333% - 20px);
    min-width: 300px;
    scroll-snap-align: start;
    background: #f97d01;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: all 0.4s;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);

      .card-image img {
        transform: scale(1.1);
      }

      .detail-link i {
        transform: translateX(5px);
      }
    }

    .card-image {
      height: 200px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s;
      }
    }

    .card-content {
      padding: 25px;

      h3 {
        font-size: 20px;
        margin-bottom: 15px;
        color: #fff;
      }

      p {
        font-size: 15px;
        color: #fff;
        margin-bottom: 20px;
        line-height: 1.6;
      }
    }

    .detail-link {
      color: $primary-color;
      padding: 0;
      font-weight: 500;

      i {
        margin-left: 5px;
        transition: transform 0.3s;
      }
    }
  }

  .carousel-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #fff;
    border: none;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;
    transition: all 0.3s;

    &:hover {
      background: $primary-color;
      color: #fff;
    }

    &.prev {
      left: 0;
    }

    &.next {
      right: 0;
    }

    i {
      font-size: 20px;
      font-weight: bold;
    }
  }
}
.pricing-page {
  padding: 60px 0;
  background-color: #f9f9f9;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-title {
  text-align: center;
  font-size: 32px;
  color: #333;
  margin-bottom: 15px;
}

.section-subtitle {
  text-align: center;
  font-size: 18px;
  color: #666;
  max-width: 700px;
  margin: 0 auto 40px;
}

/* 产品特点样式 */
.features-list {
  margin-top: 40px;
}

.feature-card {
  background: #fff;
  border-radius: 8px;
  padding: 30px 25px;
  margin-bottom: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  text-align: center;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  font-size: 48px;
  margin-bottom: 20px;
}

.feature-card h3 {
  font-size: 20px;
  margin-bottom: 15px;
  color: #333;
}

.feature-card p {
  color: #666;
  font-size: 15px;
  line-height: 1.6;
}

/* CTA按钮样式 */
.cta-buttons {
  text-align: center;
  margin-top: 50px;
}

.cta-button {
  padding: 12px 30px;
  font-size: 16px;
  margin: 0 10px;
}

.cta-button i {
  margin-right: 8px;
}

/* 常见问题样式 */
.faq-section {
  margin-top: 80px;
  padding: 60px 0;
  background-color: #fff;
}

.faq-accordion {
  max-width: 800px;
  margin: 0 auto;
}

.faq-title {
  font-size: 18px;
  font-weight: 500;
  padding: 15px 0;
}

.faq-title i {
  margin-right: 10px;
}

.faq-content {
  padding: 0 20px 20px 34px;
  color: #666;
  line-height: 1.8;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .section-title {
    font-size: 28px;
  }

  .section-subtitle {
    font-size: 16px;
  }

  .cta-buttons {
    display: flex;
    flex-direction: column;
  }

  .cta-button {
    margin: 10px 0;
    width: 100%;
  }
}
</style>
